export default __webpack_public_path__ + "static/media/b3.39236774.jpg";